module.exports = __webpack_public_path__ + "static/media/logo_3DCommerce.ade14dee.jpg";